export default __webpack_public_path__ + "static/media/testing.d4df6579.png";